export const dark = {
    body: "#5a5a5a", // Black (Main Background)
    text: "#ffffff", //9 Ivory (Main Text)
    cardBackground: "#ffffff ", // <--- ADDED: Ivory for Cards
    bodyRgba : "26, 26, 26", 
    textRgba:"248, 241, 233",
    carouselColor: "#9a9a9a",// Warm Gray
    fontxs:'0.75em',
    fontsm:'0.875em',
    fontmd:'1em', 
    fontlg:'1.25em',
    fontxl:'2em',
    fontxxl:'3em',
    fontxxxl:'4em',
    fontButton:'0.875em',
    navHeight: '5rem',
}

export const light = {
    // INVERSE OF LIGHT THEME
    body: "#ffffff", // Ivory (Alt Background)
    text: "#4a4a4a", // Black (Alt Text)
    cardBackground: "#4a4a4a", // <--- ADDED: Black for Cards (Contrast against Ivory body)
    bodyRgba : "248, 241, 233", 
    textRgba:"26, 26, 26",
    carouselColor: "#ffffff", // Warm Gray
    fontxs:'0.75em',
    fontsm:'0.875em',
    fontmd:'1em', 
    fontlg:'1.25em',
    fontxl:'2em',
    fontxxl:'3em',
    fontxxxl:'4em',
    fontButton:'0.875em',
    navHeight: '5rem',
}